const useModalHandlers = (
  attributes,
  setModalTitle,
  setModuleName,
  setIsModalVisible,
  setFormData,
  setAttributesData
) => {
  const showModal = (name) => {
    setModalTitle(name);
    setModuleName(name);
    setIsModalVisible(true);
    const matchedSection =
      attributes &&
      attributes.find((section) => section && section.name === name);
    console.log("name & match", name, matchedSection);
    if (matchedSection && matchedSection.attributes) {
      let orderedNames = [];
      if (name === "Vehicle Information") {
        orderedNames = ["Year", "Make", "Model", "Maintenance Status", "Notes"]; // you can extend for other sections
      }
      const reorderedAttributes = [
        // attributes that match the custom order
        ...orderedNames
          .map((orderName) =>
            matchedSection.attributes.find(
              (attr) =>
                attr.name && attr.name.toLowerCase() === orderName.toLowerCase()
            )
          )
          .filter(Boolean),
        // remaining attributes not in custom order
        ...matchedSection.attributes.filter(
          (attr) =>
            !orderedNames.some(
              (orderName) =>
                orderName.toLowerCase() === attr.name && attr.name.toLowerCase()
            )
        ),
      ];

      setAttributesData({ ...matchedSection, attributes: reorderedAttributes });
    } else {
      setAttributesData(matchedSection || null);
    }
  };

  const updateModal = (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("Update");
    const matchedSection =
      attributes &&
      attributes.find((section) => section && section.name === record.module);
    if (matchedSection && matchedSection.attributes) {
      let orderedNames = [];
      if (record.module === "Vehicle Information") {
        orderedNames = ["Year", "Make", "Model", "Maintenance Status", "Notes"]; // you can extend for other sections
      }
      const reorderedAttributes = [
        // attributes that match the custom order
        ...orderedNames
          .map((orderName) =>
            matchedSection.attributes.find(
              (attr) =>
                attr.name && attr.name.toLowerCase() === orderName.toLowerCase()
            )
          )
          .filter(Boolean),
        // remaining attributes not in custom order
        ...matchedSection.attributes.filter(
          (attr) =>
            !orderedNames.some(
              (orderName) =>
                orderName.toLowerCase() === attr.name && attr.name.toLowerCase()
            )
        ),
      ];

      setAttributesData({ ...matchedSection, attributes: reorderedAttributes });
    } else {
      setAttributesData(matchedSection || null);
    }
  };

  const viewModal = (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("View Item");
    const matchedSection =
      attributes &&
      attributes.find((section) => section && section.name === record.module);
    if (matchedSection && matchedSection.attributes) {
      let orderedNames = [];
      if (record.module === "Vehicle Information") {
        orderedNames = ["Year", "Make", "Model", "Maintenance Status", "Notes"]; // you can extend for other sections
      }
      const reorderedAttributes = [
        // attributes that match the custom order
        ...orderedNames
          .map((orderName) =>
            matchedSection.attributes.find(
              (attr) =>
                attr.name && attr.name.toLowerCase() === orderName.toLowerCase()
            )
          )
          .filter(Boolean),
        // remaining attributes not in custom order
        ...matchedSection.attributes.filter(
          (attr) =>
            !orderedNames.some(
              (orderName) =>
                orderName.toLowerCase() === attr.name && attr.name.toLowerCase()
            )
        ),
      ];

      setAttributesData({ ...matchedSection, attributes: reorderedAttributes });
    } else {
      setAttributesData(matchedSection || null);
    }
  };
  const handelCloseModal = () => {
    setIsModalVisible(false);
    setAttributesData(null);
    setFormData(null);
  };

  return { showModal, updateModal, viewModal, handelCloseModal };
};

export default useModalHandlers;
